import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import classNames from "classnames"

import styles from "assets/scss/index.module.scss"
import logo from "assets/svg/logo-white.svg"
import { ReactComponent as IconDevice } from "assets/svg/menu-device.svg"
import { ReactComponent as IconOrders } from "assets/svg/menu-orders.svg"

import { useNewOrdersQuantity } from "hooks/useNewOrdersQuantity"
import { Hamburger } from "components/common/Hamburger"
import MenuWrapper from "components/common/MenuWrapper"
import { NavLink } from "components/common/NavLink"
import { UserMenu } from "components/common/UserMenu"

import { RightSideIconsWrapper } from "../styled"

export const WerehouseTopbar = () => {
  const { data } = useNewOrdersQuantity()
  const [isSticky, setSticky] = useState(false)
  const [isOpen, setOpen] = useState(false)

  const closeMenu = () => {
    setOpen(false)
  }

  const handleScroll = () => {
    const distance = window.scrollY

    if (distance > 0 && !isSticky) {
      setSticky(true)
    } else if (distance === 0 && isSticky) {
      setSticky(false)
    }
  }

  useEffect(() => {
    const setStickyOnScroll = () => handleScroll()

    window.addEventListener("scroll", setStickyOnScroll)

    return () => {
      window.removeEventListener("scroll", setStickyOnScroll)
    }
  }, [isSticky])

  return (
    <header className={classNames(styles.topbar, { [styles.sticky]: isSticky })}>
      <Link className={styles.logoWrapper} to="/">
        <img className={styles.logo} src={logo} alt="logo" />
      </Link>
      <MenuWrapper isOpen={isOpen} onClose={closeMenu}>
        <NavLink to="/wh-orders" className={styles.menuItem} activeClassName={styles.active} onClick={closeMenu}>
          <IconOrders className={styles.menuIcon} />
          Orders
          {Boolean(data?.data?.quantity) && <span className={styles.redDot}>{data?.data?.quantity}</span>}
        </NavLink>
        <NavLink to="/wh-devices" className={styles.menuItem} activeClassName={styles.active} onClick={closeMenu}>
          <IconDevice className={classNames(styles.menuIconStroke)} />
          Devices
        </NavLink>
      </MenuWrapper>
      <RightSideIconsWrapper>
        <Hamburger onClick={() => setOpen(!isOpen)} isOpen={isOpen} />
        <UserMenu />
      </RightSideIconsWrapper>
    </header>
  )
}
